import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { history } from './store'
import { PublicRoute } from './components/PublicRoute'
import { PrivateRoute } from './components/PrivateRoute';
import { PublicScopedRoute } from './components/PublicScopedRoute';
import { App } from './App'

// -----------------------------
// Starter Routes
// -----------------------------

// Pages
import { LoginPage } from './components/Auth/LoginPage'
import { SignupPage } from './components/Auth/SignupPage'
import { DashboardPage } from './components/Dashboard/DashboardPage'
import { RecoverPage } from './components/Auth/RecoverPage'
import { ResetPage } from './components/Auth/ResetPage'
import { NotFound } from './pages/NotFound/NotFound'
import { ProfilePage } from './components/User/ProfilePage'
import { TermsPage } from './components/Public/TermsPage'

// Account Pages
import { SettingsPage } from './components/Account/SettingsPage'
import { BillingPage } from './components/Billing/BillingPage'
import { BillingSuccessPage } from './components/Billing/BillingSuccessPage'
import { TeamPage } from './components/Account/TeamPage'
import { UserPage } from './components/User/UserPage'
import { AccountSwitcherPage } from './components/User/AccountSwiterPage'
import { SwitchAccount } from './components/Auth/SwitchAccount'

// Network Admin
import { NetworkDashboard } from './components/Network/NetworkDashboard'
import { NetworkUsersPage } from './components/Network/NetworkUsersPage'
import { NetworkAccountsPage } from './components/Network/NetworkAccountsPage'
import { NetworkEditAccountsPage } from './components/Network/NetworkEditAccountsPage'
import { NetworkNetworksPage } from './components/Network/NetworkNetworksPage'
import { EditNetworkPage } from './components/Network/EditNetworkPage'
import { NetworkEditUserPage } from './components/Network/NetworkEditUserPage'
import { NetworkIntegrationPage } from './components/Network/NetworkIntegrationsPage'

// Network Products
import { NetworkProductPage } from './modules/NetworkProducts/NetworkProductPage';
import { EditNetworkProductPage } from './modules/NetworkProducts/EditNetworkProductPage';
import { ViewNetworkProductPage } from './modules/NetworkProducts/ViewNetworkProductPage';
import { ViewNetworkProductSuccessPage } from './modules/NetworkProducts/ViewNetworkProductSuccessPage';
import { PublicNetworkProductPage } from './modules/NetworkProducts/PublicNetworkProductPage';
import { PublicNetworkProductSuccessPage } from './modules/NetworkProducts/PublicNetworkProductSuccessPage';

// Network Orders
import { AccountNetworkOrdersPage } from './modules/NetworkOrders/AccountNetworkOrdersPage';
import { AccountViewNetworkOrderPage } from './modules/NetworkOrders/AccountViewNetworkOrderPage';
import { NetworkOrdersPage } from './modules/NetworkOrders/NetworkOrdersPage';
import { ViewNetworkOrderPage } from './modules/NetworkOrders/ViewNetworkOrderPage';

// Labs
import { LabsPage } from './modules/Labs/LabsPage';
import { RepeaterLab } from './modules/Labs/RepeaterLab';
import { TextInputsLab } from './modules/Labs/TextInputsLab';
import { DateInputsLab } from './modules/Labs/DateInputsLab';
import { RadioLab } from './modules/Labs/RadioLab';
import { DesignSystem } from './modules/Labs/DesignSystem';
import { MediaLab } from './modules/Labs/MediaLab';
import { PayWallLab } from './modules/Labs/PayWallLab';
import { VideoLab } from './modules/Labs/VideoLab';
import { ColorPickerLab } from './modules/Labs/ColorPickerLab';


// -----------------------------
// App Routes
// -----------------------------

// Example Content
import { ExampleContentPage } from './modules/ExampleContent/ExampleContentPage';
import { EditExampleContentPage } from './modules/ExampleContent/EditExampleContentPage';

// Example Taxonomy
import { ExampleTaxonomyPage } from './modules/ExampleTaxonomy/ExampleTaxonomyPage';
import { EditExampleTaxonomyPage } from './modules/ExampleTaxonomy/EditExampleTaxonomyPage';

// Media Library
import { MediaPage } from './modules/Media/MediaPage';
import { NetworkMediaPage } from './modules/Media/NetworkMediaPage';
import { EditMediaPage } from './modules/Media/EditMediaPage';
import { MediaTagsPage } from './modules/Media/MediaTagsPage';
import { EditMediaTagPage } from './modules/Media/EditMediaTagPage';
import { NetworkEditMediaPage } from './modules/Media/NetworkEditMediaPage';
import { NetworkMediaTagsPage } from './modules/Media/NetworkMediaTagsPage';
import { NetworkEditMediaTagPage } from './modules/Media/NetworkEditMediaTagPage';
import { MapsLab } from './modules/Labs/MapsLab'
import { PageNetworkContent } from './modules/NetworkContent/PageNetworkContent'
import { PageEditNetworkContent } from './modules/NetworkContent/PageEditNetworkContent'
import { ViewNetworkContent } from './modules/NetworkContent/ViewNetworkContent'
import { MediaProcessingLab } from './modules/Labs/MediaProcessingLab'


// --------------------------
// CAPTURE COLLAB
// --------------------------
import { PageDashboard } from './capturecollab/components/Dashboard/PageDashboard';
import { AlbumsPage } from './capturecollab/modules/Album/AlbumsPage';
import { LibraryPage } from './capturecollab/modules/Library/LibraryPage'
import { PeoplePage } from './capturecollab/modules/People/PeoplePage'
import { LocationsPage } from './capturecollab/modules/Location/LocationsPage'
import { LocationPage } from './capturecollab/modules/Location/LocationPage'
import { PersonPage } from './capturecollab/modules/People/PersonPage'
import { LibraryAlbumsPage } from './capturecollab/modules/Library/LibraryAlbumsPage'
import { PageUpload } from './capturecollab/modules/Library/PageUpload'
import { PageAssets } from './capturecollab/modules/Assets/PageAssets'
import { PageLibrarySettings } from './capturecollab/modules/Library/PageLibrarySettings'
import { PageAlbumSettings } from './capturecollab/modules/Album/PageAlbumSettings'
import { PagePersonSettings } from './capturecollab/modules/People/PagePersonSettings'
import { PageLocationSettings } from './capturecollab/modules/Location/PageLocationSettings'
import { PageSaved } from './capturecollab/modules/UserEngagement/PageSaved'
import { PageAsset } from './capturecollab/modules/Assets/PageAsset'
import { validPlans } from './config'
import { AccountSettingsPage } from './components/Account/AccountSettingsPage'
import { PageOnboardingNewUser } from './capturecollab/modules/Onboarding/PageOnboardingNewUser'
import { GenericTagsPage } from './capturecollab/modules/GenericTags/GenericTagsPage'
import { GenericTagPage } from './capturecollab/modules/GenericTags/GenericTagPage'
import { PageGenericTagSettings } from './capturecollab/modules/GenericTags/PageGenericTagSettings'
import { PageSearch } from './capturecollab/components/Search/PageSearch'
import { ViewsPage } from './capturecollab/modules/Views/ViewsPage'
import { ViewPage } from './capturecollab/modules/Views/ViewPage'
import { PageViewSettings } from './capturecollab/modules/Views/PageViewSettings'
import { PublicView } from './capturecollab/modules/Views/PublicView'
import { PageOnboarding } from './capturecollab/modules/Onboarding/PageOnboarding'
import { PageLibaries } from './capturecollab/modules/Library/PageLibraries'

// --------------------------
// Scroll To Top on Route Change
// --------------------------

history.listen(() => { window.scrollTo(0, 0); })


/**
 * The main routes of the application. Utilize this function to add more.
 */
export const routes = (
  <ConnectedRouter history={history}>
    <Switch>

      <PublicRoute exact path="/login" title="Login" component={LoginPage} />
      <PublicRoute exact path="/signup" title="Signup" component={SignupPage} />
      <PublicRoute exact path="/recover-password" title="Recover Password" component={RecoverPage} />
      <PublicRoute exact path="/reset-password/:token" title="Reset Password" component={ResetPage} />
      <PublicRoute exact path="/terms" title="Terms" component={TermsPage} />

      {/***** Account Pages *****/}
      <PrivateRoute exact path="/" title="Dashboard" component={PageDashboard} />
      <PrivateRoute exact path="/profile" title="Profile" component={ProfilePage} />
      <PrivateRoute exact path="/settings" title="Settings" component={SettingsPage} role="owner|admin|editor|viewer" />
      <PrivateRoute exact path="/settings/account" title="Settings" component={AccountSettingsPage} role="owner" />
      <PrivateRoute exact path="/billing" title="Billing" component={BillingPage} role="owner" bypassCheck="paymentStatus|subscriptionStatus" />
      <PrivateRoute exact path="/billing/success" title="Billing" component={BillingSuccessPage} role="owner" bypassCheck="paymentStatus|subscriptionStatus" />
      <PrivateRoute exact path="/team" title="Team" component={TeamPage} role="owner|admin" plan={validPlans} />
      <PrivateRoute exact path="/user/:id" title="User" component={UserPage} role="owner|admin" />
      <PrivateRoute exact path="/accounts" title="Accounts" component={AccountSwitcherPage} />
      <PrivateRoute exact path="/account/:id" title="Account" component={SwitchAccount} />

      {/***** Network Admin *****/}
      <PrivateRoute exact path="/network" title="Network Dashboard" component={NetworkDashboard} networkRole="networkadmin|networkeditor" />
      <PrivateRoute exact path="/network/accounts" title="Network Accounts" component={NetworkAccountsPage} networkRole="networkadmin" />
      <PrivateRoute exact path="/network/accounts/:id" title="Network Edit Accounts" component={NetworkEditAccountsPage} networkRole="networkadmin" />
      <PrivateRoute exact path="/network/users" title="Network Users" component={NetworkUsersPage} networkRole="networkadmin" />
      <PrivateRoute exact path="/network/users/:id" title="Network User" component={NetworkEditUserPage} networkRole="networkadmin" />
      <PrivateRoute exact path="/network/networks" title="Network List" component={NetworkNetworksPage} networkRole="superadmin" />
      <PrivateRoute exact path="/network/edit/:id" title="Network Edit" component={EditNetworkPage} networkRole="networkadmin" />
      <PrivateRoute exact path="/network/:id/integrations" title="Network Integrations" component={NetworkIntegrationPage} networkRole="networkadmin" />
      <PrivateRoute exact path="/network/:id/integrations/:app" title="Network Integrations" component={NetworkIntegrationPage} networkRole="networkadmin" />

      {/***** Network Products & Orders *****/}
      <PrivateRoute exact path="/network/products" title="Network Products" component={NetworkProductPage} networkRole="networkadmin" />
      <PrivateRoute exact path="/network/products/:id" title="Network Product" component={EditNetworkProductPage} networkRole="networkadmin" />
      <PrivateRoute exact path="/billing/products/:id" title="Network Billing" component={ViewNetworkProductPage} role="owner" />
      <PrivateRoute exact path="/billing/products/:id/success" title="Network Billing" component={ViewNetworkProductSuccessPage} role="owner" />
      <PrivateRoute exact path="/billing/orders" title="Network Orders" component={AccountNetworkOrdersPage} role="owner" />
      <PrivateRoute exact path="/billing/orders/:id" title="Network Order" component={AccountViewNetworkOrderPage} role="owner" />
      <PrivateRoute exact path="/network/orders" title="Network Orders" component={NetworkOrdersPage} networkRole="networkadmin" />
      <PrivateRoute exact path="/network/orders/:id" title="Network Order" component={ViewNetworkOrderPage} networkRole="networkadmin" />
      <PublicScopedRoute exact path="/products/:id" title="Products" component={PublicNetworkProductPage} />
      <PublicScopedRoute exact path="/products/:id/success" title="Product" component={PublicNetworkProductSuccessPage} />

      {/***** Media *****/}
      <PrivateRoute exact path="/media" title="Media" component={MediaPage} role="owner|admin|editor" />
      <PrivateRoute exact path="/media/tags" title="Media Tags" component={MediaTagsPage} role="owner|admin|editor" />
      <PrivateRoute exact path="/media/tags/:id" title="Media Tag" component={EditMediaTagPage} role="owner|admin|editor" />
      <PrivateRoute exact path="/media/:id" title="Media Item" component={EditMediaPage} role="owner|admin|editor" />
      <PrivateRoute exact path="/network/media" title="Network Media" component={NetworkMediaPage} networkRole="networkadmin" />
      <PrivateRoute exact path="/network/media/tags" title="Network Media Tags" component={NetworkMediaTagsPage} networkRole="networkadmin" />
      <PrivateRoute exact path="/network/media/tags/:id" title="Network Media Tag" component={NetworkEditMediaTagPage} networkRole="networkadmin" />
      <PrivateRoute exact path="/network/media/:id" title="Netork Media Item" component={NetworkEditMediaPage} networkRole="networkadmin" />
      <PrivateRoute exact path="/network/content" title="Network Content" component={PageNetworkContent} networkRole="networkadmin" />
      <PrivateRoute exact path="/network/content/:id" title="Edit Network Content" component={PageEditNetworkContent} networkRole="networkadmin" />
      <PrivateRoute exact path="/networkcontent/:id" title="View Network Content" component={ViewNetworkContent} role="owner|admin|editor" />


      {/***** Labs *****/}
      <PrivateRoute exact path="/labs" title="Lab" component={LabsPage} />
      <PrivateRoute exact path="/labs/repeater" title="Lab" component={RepeaterLab} />
      <PrivateRoute exact path="/labs/textinputs" title="Lab" component={TextInputsLab} />
      <PrivateRoute exact path="/labs/dateinputs" title="Lab" component={DateInputsLab} />
      <PrivateRoute exact path="/labs/radio" title="Lab" component={RadioLab} />
      <PrivateRoute exact path="/labs/design" title="Lab" component={DesignSystem} />
      <PrivateRoute exact path="/labs/media" title="Lab" component={MediaLab} />
      <PrivateRoute exact path="/labs/media/processing" title="Lab" component={MediaProcessingLab} />
      <PrivateRoute exact path="/labs/video" title="Lab" component={VideoLab} />
      <PrivateRoute exact path="/labs/colorpicker" title="Lab" component={ColorPickerLab} />
      <PrivateRoute exact path="/labs/maps" title="Maps" component={MapsLab} />

      <PublicRoute exact path="/labs/paywall" title="Lab: PayWall" component={PayWallLab} />

      {/***** This App *****/}
      <PrivateRoute exact path="/search" title="Search" component={PageSearch} role="owner|admin|editor|viewer" plan={validPlans} />
      <PrivateRoute exact path="/libraries" title="Libraries" component={PageLibaries} role="owner|admin|editor|viewer" plan={validPlans} />
      <PrivateRoute exact path="/library/:id" title="Library" component={LibraryPage} role="owner|admin|editor|viewer" plan={validPlans} />
      <PrivateRoute exact path="/library/:id/albums" title="Albums" component={LibraryAlbumsPage} role="owner|admin|editor|viewer" plan={validPlans} />
      {/* <PrivateRoute exact path="/library/:id/people" title="People" component={PageLibrarySettings} role="owner|admin|editor|viewer" plan={validPlans} /> */}
      {/* <PrivateRoute exact path="/library/:id/locations" title="People" component={PageLibrarySettings} role="owner|admin|editor|viewer" plan={validPlans} /> */}
      <PrivateRoute exact path="/library/:id/settings" title="Library Settings" component={PageLibrarySettings} role="owner|admin" />
      <PrivateRoute exact path="/library/:id/upload" title="Upload" component={PageUpload} role="owner|admin|editor" plan={validPlans} />
      <PrivateRoute exact path="/library/:id/album/:albumId" title="Albums" component={PageAssets} role="owner|admin|editor|viewer" plan={validPlans} />
      <PrivateRoute exact path="/library/:id/album/:albumId/upload" title="Upload" component={PageUpload} role="owner|admin|editor" plan={validPlans} />
      <PrivateRoute exact path="/library/:libraryId/album/:albumId/settings" title="Album Settings" component={PageAlbumSettings} role="owner|admin" plan={validPlans} />
      {/* <PrivateRoute exact path="/albums" title="Albums" component={AlbumsPage} role="owner|admin|editor|viewer" /> */}
      {/* <PrivateRoute exact path="/albums/:id" title="Albums" component={LibraryPage} role="owner|admin|editor|viewer" /> */}
      <PrivateRoute exact path="/people" title="People" component={PeoplePage} role="owner|admin" plan={validPlans} />
      <PrivateRoute exact path="/people/:id" title="Person" component={PersonPage} role="owner|admin" plan={validPlans} />
      <PrivateRoute exact path="/people/:id/settings" title="Person" component={PagePersonSettings} role="owner|admin" plan={validPlans} />
      <PrivateRoute exact path="/locations" title="Location" component={LocationsPage} role="owner|admin" plan={validPlans} />
      <PrivateRoute exact path="/locations/:id" title="Location" component={LocationPage} role="owner|admin" plan={validPlans} />
      <PrivateRoute exact path="/locations/:id/settings" title="Location" component={PageLocationSettings} role="owner|admin" plan={validPlans} />
      {/* <PrivateRoute exact path="/albums/:id" title="Albums" component={LibraryPage} role="owner|admin|editor|viewer" /> */}
      <PrivateRoute exact path="/saved" title="Saved" component={PageSaved} role="owner|admin|editor|viewer" plan={validPlans} />
      <PrivateRoute exact path="/asset/:assetId" title="Asset" component={PageAsset} role="owner|admin|editor|viewer" plan={validPlans} />
      <PublicRoute exact path="/onboarding/newuser/:token" title="Complete Account" component={PageOnboardingNewUser} />
      <PrivateRoute exact path="/onboarding" title="Onboarding" component={PageOnboarding} role="owner" />
      <PrivateRoute exact path="/tags" title="Tags" component={GenericTagsPage} role="owner|admin" plan={validPlans} />
      <PrivateRoute exact path="/tags/:id" title="Tag" component={GenericTagPage} role="owner|admin" plan={validPlans} />
      <PrivateRoute exact path="/tags/:id/settings" title="Tag" component={PageGenericTagSettings} role="owner|admin" plan={validPlans} />
      <PrivateRoute exact path="/views" title="Views" component={ViewsPage} role="owner|admin|editor|viewer" plan={validPlans} />
      <PrivateRoute exact path="/views/:id" title="View" component={ViewPage} role="owner|admin|editor|viewer" plan={validPlans} />
      <PrivateRoute exact path="/views/:id/settings" title="View" component={PageViewSettings} role="owner|admin" plan={validPlans} />
      <PublicScopedRoute exact path="/viewer/:id" title="View Gallery" component={PublicView} />

      <PublicRoute path="/*" component={NotFound} />
    </Switch>
  </ConnectedRouter>
)

export const RouteBreadCrumbs = {
  dashboard: { href: '/', title: 'Dashboard' },
  team: { href: '/team', title: 'Team' },
  media: { href: '/media', title: 'Media' },
  mediaTags: { href: '/media/tags', title: 'Media Tags' },
  billing: { href: '/billing', title: 'Billing' },
  billingOrders: { href: '/billing/orders', title: 'Orders' },

  // Network
  network: { href: '/network', title: 'Network' },
  networkUsers: { href: '/network/users', title: 'Users' },
  networkMedia: { href: '/network/media', title: 'Network Media' },
  networkMediaTags: { href: '/network/media/tags', title: 'Network Media Tags' },
  networkOrders: { href: '/network/orders', title: 'Orders' },
  networkProducts: { href: '/network/products', title: 'Products' },

  // CAPTURE COLLAB
  libraries: { href: '/libraries', title: 'All Collections' },

}